module.exports = __webpack_public_path__ + "img/logo-dark.ed46bc61.png";